import { render, staticRenderFns } from "./ListPaper.vue?vue&type=template&id=1e89bb0c&scoped=true&"
import script from "./ListPaper.vue?vue&type=script&lang=js&"
export * from "./ListPaper.vue?vue&type=script&lang=js&"
import style0 from "./ListPaper.vue?vue&type=style&index=0&id=1e89bb0c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e89bb0c",
  null
  
)

export default component.exports